export const formatCoordinatesToString = (latitude, longitude) => {
    return latitude.toFixed(6) + ',' + longitude.toFixed(6);
};
export const isCoordinates = (input) => {
    const sanitizedInput = input.replace(/\s+/g, '');
    const coordinatesPattern = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/;
    return coordinatesPattern.test(sanitizedInput);
};
export const parseCoordinates = (input) => {
    const [latitude, longitude] = input.split(',').map(Number);
    return { longitude, latitude };
};
